<ng-container [ngSwitch]="serviceType">
  <app-ambulance-confirmed *ngSwitchCase="'Ambulancia'"></app-ambulance-confirmed>
  <app-medical-checkup-confirmed *ngSwitchCase="'Check-up Médico'"></app-medical-checkup-confirmed>
  <app-medical-checkup-confirmed *ngSwitchCase="'Check Up'"></app-medical-checkup-confirmed>
  <div *ngSwitchDefault>
    <p>No hay componente de confirmación disponible para este servicio: {{ serviceType }}</p>
  </div>
</ng-container>